import React from 'react';
const ResetIcon = ({ size=18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 12a9 9 0 1 1 9 9" />
    <path d="M3 12h4" />
    <path d="M3 12l3 3" />
  </svg>
);
export default ResetIcon;